import { useCallback } from 'react';

import { logger } from '@luna/logger';
import { PublicService } from '@api-client/temporary-messages';

import { useTemporaryMessagesState } from '../useTemporaryMessagesState';

interface Hook {
    closeMessage(messageId: string): void;
}

export function useTemporaryMessageActions(): Hook {
    const { dispatchActions } = useTemporaryMessagesState();

    const closeMessage = useCallback(
        (messageId: string): void => {
            dispatchActions.addClosedMessageId(messageId);
            closeTemporaryMessage(messageId).catch((err) => logger.error(err));
        },
        [dispatchActions],
    );

    return {
        closeMessage,
    };
}

function closeTemporaryMessage(messageId: string): Promise<void> {
    return PublicService.postPublicTemporaryMessagesClosed({ id: messageId });
}
